import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentSchedulingPage() {
  return (
    <LatamAgentPage locale="en-LATAM" agentKey="scheduling_and_re_scheduling" />
  );
}
